import React, { PropsWithChildren } from 'react';

import { StyledBox } from './styles';
import { BoxArgs } from './index';

export const Box = ({ children, dataLocator, ...commonProps }: PropsWithChildren<BoxArgs>) => {
    return (
        <StyledBox data-locator={dataLocator} {...commonProps}>
            {children}
        </StyledBox>
    );
};
